module.exports = __webpack_public_path__ + "img/57ea4d4.jpg";